import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { HelperService } from 'src/app/public/helper.service';
import { Category } from 'src/app/stores/stores';

@Component({
  selector: 'app-top-catalog-view',
  templateUrl: './top-catalog-view.component.html',
  styleUrls: ['./top-catalog-view.component.scss'],
})
export class TopCatalogViewComponent implements OnInit {
  @Input() topCategoryContainerMarginBottom: number;
  @Input() gutterBottom;
  @Input() topLevelCategories: Category[];
  @Input() hasOtherTopLevelCategories: boolean;
  
  @Output() categorySelected = new EventEmitter<number>();
  
  isGoApp = false;
  isIOSApp:boolean;
  currentStyles = {};
  constructor(private helper: HelperService, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.isGoApp = this.helper.isGoApp();
    this.isIOSApp = Capacitor.getPlatform() === 'ios';
    this.updateStyles();
  }

  onSelectTopLevelCategory(categoryId: number) {
    this.categorySelected.emit(categoryId);
  }

  getBackgroundImage(url: any) {
    if (url) {
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
    }
    return '';
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.updateStyles();
  }
  updateStyles() {
    const screenHeight = window.innerHeight;
    this.currentStyles = this.helper.calcPaddingBottom(screenHeight, this.isIOSApp, this.topCategoryContainerMarginBottom, this.isGoApp);
  }
}
